import { useState } from 'react';
import { Button } from './ui/button';
import './BulkActionToolbar.css';

const BulkActionToolbar = ({
  selectedCount,
  onMove,
  onDelete,
  onDownload,
  onDeselectAll,
  folders,
  isGerman
}) => {
  const [showMoveMenu, setShowMoveMenu] = useState(false);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);

  if (selectedCount === 0) return null;

  return (
    <div className="bulk-action-toolbar">
      <div className="toolbar-info">
        <span className="selected-count">
          {selectedCount} {isGerman ? 'ausgewählt' : 'selected'}
        </span>
        <button onClick={onDeselectAll} className="deselect-btn">
          ✕ {isGerman ? 'Abwählen' : 'Deselect all'}
        </button>
      </div>

      <div className="toolbar-actions">
        {/* Move to Folder */}
        <div className="action-dropdown">
          <Button 
            onClick={() => setShowMoveMenu(!showMoveMenu)}
            variant="outline"
            size="sm"
          >
            📁 {isGerman ? 'Verschieben' : 'Move to'}
          </Button>
          {showMoveMenu && (
            <div className="dropdown-menu">
              <div 
                className="dropdown-item"
                onClick={() => { onMove(null); setShowMoveMenu(false); }}
              >
                📚 {isGerman ? 'Alle Geschichten' : 'All Stories'}
              </div>
              {folders.map(folder => (
                <div
                  key={folder.id}
                  className="dropdown-item"
                  onClick={() => { onMove(folder.id); setShowMoveMenu(false); }}
                >
                  <span className="folder-color" style={{ backgroundColor: folder.color }}></span>
                  {folder.name}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Download */}
        <div className="action-dropdown">
          <Button 
            onClick={() => setShowDownloadMenu(!showDownloadMenu)}
            variant="outline"
            size="sm"
          >
            📥 {isGerman ? 'Herunterladen' : 'Download'}
          </Button>
          {showDownloadMenu && (
            <div className="dropdown-menu">
              <div 
                className="dropdown-item"
                onClick={() => { onDownload('zip'); setShowDownloadMenu(false); }}
              >
                📦 {isGerman ? 'Als ZIP (einzelne PDFs)' : 'As ZIP (individual PDFs)'}
              </div>
              <div 
                className="dropdown-item"
                onClick={() => { onDownload('combined_pdf'); setShowDownloadMenu(false); }}
              >
                📄 {isGerman ? 'Als kombiniertes PDF' : 'As combined PDF'}
              </div>
            </div>
          )}
        </div>

        {/* Delete */}
        <Button 
          onClick={onDelete}
          variant="outline"
          size="sm"
          className="delete-btn"
        >
          🗑️ {isGerman ? 'Löschen' : 'Delete'}
        </Button>
      </div>
    </div>
  );
};

export default BulkActionToolbar;
